import Hero from '@/components/sections/home/hero';
import Avis from '@/components/sections/home/avis';
import Valorisation from '@/components/sections/home/valorisation';
import { Page } from '@/components/layout/page';

export default function HomePage() {
    return (
        <Page title="Les informations officielles des entreprises">
            <Hero />
            <Avis />
            <Valorisation />
        </Page>
    );
}